import { Injectable } from '@angular/core';

import { KeyValuePair } from '@reg/shared/model';

/**
 * Service to get payment options for a wrestling division's registration
 */
@Injectable()
export class PaymentOptionTypeService {
    // Consts are a copy of the PaymentOptionType enum defined in the floarena-api
    public static NONE: string = 'none';
    public static ONLINE_ONLY: string = 'online-only';
    public static ONSITE_ONLY: string = 'onsite-only';
    public static ONSITE_ONLINE: string = 'onsite-online';

    private types: KeyValuePair[] = [];

    /**
     * Constructor. Build the enum list
     */
    constructor() {
        this.types.push(new KeyValuePair(PaymentOptionTypeService.NONE, 'None (free)'));
        this.types.push(new KeyValuePair(PaymentOptionTypeService.ONLINE_ONLY, 'Online Only'));
        this.types.push(new KeyValuePair(PaymentOptionTypeService.ONSITE_ONLY, 'On-site Only'));
        this.types.push(new KeyValuePair(PaymentOptionTypeService.ONSITE_ONLINE, 'On-site & Online'));
    }

    /**
     * Get all payment options
     */
    public getIndex(): KeyValuePair[] {
        return this.types;
    }

    /**
     * Get a single payment option
     */
    public get(key: string): KeyValuePair {
        const foundTypes: KeyValuePair[] = this.types.filter((type: KeyValuePair) => type.key === key);

        if (foundTypes && foundTypes.length > 0) {
            // Found a match
            return foundTypes[0];
        }

        // No match found so construct a new one
        return new KeyValuePair(key, key);
    }
}
